var render, staticRenderFns
import script from "./NavigationMixin.vue?vue&type=script&lang=js"
export * from "./NavigationMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c655cc4",
  null
  
)

export default component.exports